import { AttachmentStatusTypeEnum } from '@interfaces/SurgeryRequest/AttachmentStatusTypeEnum';

export const mapAttachmentStatusToString: Record<AttachmentStatusTypeEnum, string> = {
	[AttachmentStatusTypeEnum.CLEAN]: 'Ready',
	[AttachmentStatusTypeEnum.PROCESSING]: 'Processing',
	[AttachmentStatusTypeEnum.UNPROCESSED]: 'Processing',
	[AttachmentStatusTypeEnum.QUARANTINE]: 'Failed',
};
